// src/utils/device.js
// Определение устройства и режима запуска (для установки приложения и push)

const ua = () => navigator.userAgent || '';

export function isIos() {
  // iPadOS представляется как Mac — отличаем по сенсорному экрану
  return /iPad|iPhone|iPod/.test(ua()) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isAndroid() {
  return /Android/i.test(ua());
}

// Приложение запущено как установленное (с экрана «Домой» / из меню приложений)
export function isStandalone() {
  return Boolean(window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone === true);
}

// Safari на iPhone/iPad, а не Chrome, Firefox, Edge, Яндекс Браузер и т.п. (у них свои метки в UA)
export function isIosSafari() {
  return isIos() && /Safari/.test(ua()) && !/CriOS|FxiOS|EdgiOS|YaBrowser|OPiOS|GSA\//.test(ua());
}

// Встроенный браузер приложения (Telegram, Instagram, Facebook, VK…) или Android WebView:
// установить сайт как приложение оттуда нельзя
export function isInAppBrowser() {
  return /Instagram|FBAN|FBAV|FB_IAB|Telegram|Line\/|VKAndroidApp|VKClient|Snapchat|; wv\)/i.test(ua());
}
